import {EnumHelper} from "../helpers/enumHelper";
import {Hash} from "../interfaces/hashInterfaces";

export enum SelectOption {
  None = 1,
  All = 2,
}

export const SelectOptionString: Hash<string> = EnumHelper.toArray(SelectOption).reduce((acc, n) => {
  acc[SelectOption[n]] = n.toString();
  return acc
}, {})